/* Floor Fix Pro - translates the Find the Right Floor Repair Product finder (and its launcher text)
   into the storefront language. English keys: assets/ffp-finder-i18n-en.json; translations: assets/ffp-finder-i18n-<lang>.json. Added 12 Oct 2026. */
(function () {
  var script = document.currentScript;
  if (!script) return;
  var lang = String(script.getAttribute('data-lang') || 'en').toLowerCase();
  var dictUrl = script.getAttribute('data-dict');
  var keysUrl = script.getAttribute('data-keys');
  if (!dictUrl || !keysUrl || lang === 'en') return;

  var D = null, loading = null;
  var ATTRS = ['aria-label', 'title', 'placeholder', 'alt'];
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1 };

  function norm(s) { return String(s).replace(/\s+/g, ' ').trim(); }
  function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  /* Strings added after the dictionaries were built (12 Oct 2026). */
  var EXTRA = {
    sv: { s: { 'Back': 'Tillbaka', 'Analytics choice': 'Val av statistik' }, t: [['{0} or wider', '{0} eller bredare'], ['{0} to under {1}', '{0} till under {1}'], ['Step {0} of {1}', 'Steg {0} av {1}'], ['Play: {0}', 'Spela upp: {0}']] },
    no: { s: { 'Back': 'Tilbake', 'Analytics choice': 'Valg for statistikk' }, t: [['{0} or wider', '{0} eller bredere'], ['{0} to under {1}', '{0} til under {1}'], ['Step {0} of {1}', 'Trinn {0} av {1}'], ['Play: {0}', 'Spill av: {0}']] },
    da: { s: { 'Back': 'Tilbage', 'Analytics choice': 'Valg af statistik' }, t: [['{0} or wider', '{0} eller bredere'], ['{0} to under {1}', '{0} til under {1}'], ['Step {0} of {1}', 'Trin {0} af {1}'], ['Play: {0}', 'Afspil: {0}']] },
    de: { s: { 'Back': 'Zurück', 'Analytics choice': 'Auswahl zur Analyse' }, t: [['{0} or wider', '{0} oder breiter'], ['{0} to under {1}', '{0} bis unter {1}'], ['Step {0} of {1}', 'Schritt {0} von {1}'], ['Play: {0}', 'Abspielen: {0}']] },
    fr: { s: { 'Back': 'Retour', 'Analytics choice': 'Choix des statistiques' }, t: [['{0} or wider', '{0} ou plus'], ['{0} to under {1}', 'De {0} à moins de {1}'], ['Step {0} of {1}', 'Étape {0} sur {1}'], ['Play: {0}', 'Lire : {0}']] },
    it: { s: { 'Back': 'Indietro', 'Analytics choice': 'Scelta sulle statistiche' }, t: [['{0} or wider', '{0} o più'], ['{0} to under {1}', 'Da {0} a meno di {1}'], ['Step {0} of {1}', 'Passaggio {0} di {1}'], ['Play: {0}', 'Riproduci: {0}']] },
    es: { s: { 'Back': 'Atrás', 'Analytics choice': 'Elección de analíticas' }, t: [['{0} or wider', '{0} o más'], ['{0} to under {1}', 'De {0} a menos de {1}'], ['Step {0} of {1}', 'Paso {0} de {1}'], ['Play: {0}', 'Reproducir: {0}']] },
    nl: { s: { 'Back': 'Terug', 'Analytics choice': 'Keuze voor statistieken' }, t: [['{0} or wider', '{0} of breder'], ['{0} to under {1}', '{0} tot minder dan {1}'], ['Step {0} of {1}', 'Stap {0} van {1}'], ['Play: {0}', 'Afspelen: {0}']] }
  };

  function prep(en, tr) {
    var raw = { s: {}, t: [] }, i, x = EXTRA[lang] || { s: {}, t: [] };
    for (i = 0; i < en.k.length; i++) if (tr.v[i]) raw.s[en.k[i]] = tr.v[i];
    for (i in x.s) if (Object.prototype.hasOwnProperty.call(x.s, i)) raw.s[i] = x.s[i];
    for (i = 0; i < en.t.length; i++) if (tr.t[i]) raw.t.push([en.t[i], tr.t[i]]);
    raw.t = raw.t.concat(x.t);
    var pats = raw.t.map(function (p) {
      var parts = p[0].split(/\{(\d)\}/), re = '^', order = [];
      for (var i = 0; i < parts.length; i++) {
        if (i % 2) { re += '(.*?)'; order.push(+parts[i]); } else { re += esc(parts[i]); }
      }
      return { re: new RegExp(re + '$'), order: order, out: p[1] };
    });
    return { map: raw.s || {}, pats: pats };
  }

  function load() {
    if (!loading) {
      var get = function (u) { return fetch(u, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }); };
      loading = Promise.all([get(keysUrl), get(dictUrl)])
        .then(function (a) { D = a[0] && a[1] ? prep(a[0], a[1]) : null; return D; })
        .catch(function () { return null; });
    }
    return loading;
  }

  function lookup(k) {
    return Object.prototype.hasOwnProperty.call(D.map, k) ? D.map[k] : null;
  }

  /* Some finder paragraphs join several sentences in one text node; translate the longest runs that match. */
  function translate(text) {
    var k = norm(text);
    if (!k || !/[A-Za-z]/.test(k)) return null;
    var whole = translateOne(k);
    if (whole !== null) return whole;
    var seg = k.split(/(?:[.!?])\s+(?=[A-Z])/);
    if (seg.length < 2) return null;
    var ends = k.match(/[.!?](?=\s+[A-Z])/g) || [];
    for (var s = 0; s < seg.length - 1; s++) seg[s] += ends[s];
    var out = [], hits = 0, i = 0;
    while (i < seg.length) {
      var done = false;
      for (var j = seg.length; j > i; j--) {
        var t = translateOne(seg.slice(i, j).join(' '));
        if (t !== null) { out.push(t); hits++; i = j; done = true; break; }
      }
      if (!done) { out.push(seg[i]); i++; }
    }
    return hits ? out.join(' ') : null;
  }

  function translateOne(k) {
    var hit = lookup(k);
    if (hit !== null) return hit;
    for (var i = 0; i < D.pats.length; i++) {
      var p = D.pats[i], m = k.match(p.re);
      if (!m) continue;
      var out = p.out;
      for (var j = 0; j < p.order.length; j++) {
        var v = m[j + 1] || '';
        var tv = v ? lookup(norm(v)) : null;
        if (tv !== null && /^\s/.test(v)) tv = ' ' + tv;
        out = out.replace('{' + p.order[j] + '}', tv !== null ? tv : v);
      }
      return out;
    }
    return null;
  }

  function doText(node) {
    var v = node.nodeValue;
    if (!v || node.__ffpDone === v) return;
    var t = translate(v);
    if (t !== null) {
      var lead = v.match(/^\s*/)[0], trail = v.match(/\s*$/)[0];
      if (/\($/.test(t)) trail = '';
      if (/^\)/.test(t)) lead = '';
      var nv = lead + t + trail;
      if (nv !== v) node.nodeValue = nv;
    }
    node.__ffpDone = node.nodeValue;
  }

  function doAttrs(el) {
    for (var i = 0; i < ATTRS.length; i++) {
      var a = ATTRS[i], v = el.getAttribute && el.getAttribute(a);
      if (!v || el['__ffp_' + a] === v) continue;
      var t = translate(v);
      if (t !== null && t !== v) el.setAttribute(a, t);
      el['__ffp_' + a] = el.getAttribute(a);
    }
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { doText(root); return; }
    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;
    if (root.nodeType === 1) { if (SKIP[root.tagName]) return; doAttrs(root); }
    var doc = root.ownerDocument || root;
    var w = doc.createTreeWalker(root, 5 /* element + text */, null);
    var n;
    while ((n = w.nextNode())) {
      if (n.nodeType === 3) {
        if (!n.parentNode || !SKIP[n.parentNode.tagName]) doText(n);
      } else if (!SKIP[n.tagName]) doAttrs(n);
    }
  }

  function observe(root) {
    if (!root || root.__ffpObserved) return;
    root.__ffpObserved = true;
    var Obs = (root.ownerDocument && root.ownerDocument.defaultView && root.ownerDocument.defaultView.MutationObserver) || MutationObserver;
    new Obs(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'characterData') doText(r.target);
        else if (r.type === 'attributes') doAttrs(r.target);
        else for (var j = 0; j < r.addedNodes.length; j++) walk(r.addedNodes[j]);
      }
    }).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
  }

  /* Finder iframe (same-origin srcdoc) */
  function hookFrame(frame) {
    if (!frame || frame.__ffpHooked) return;
    frame.__ffpHooked = true;
    frame.addEventListener('load', function () {
      var doc;
      try { doc = frame.contentDocument; } catch (e) { return; }
      if (!doc || !doc.documentElement) return;
      doc.documentElement.setAttribute('lang', lang);
      load().then(function () {
        if (!D || !doc.body) return;
        walk(doc.body);
        observe(doc.body);
      });
    });
  }

  /* Launcher, modal labels and loading text on the store page */
  function hookPage() {
    var modal = document.querySelector('[data-ffp-finder]');
    if (!modal) return;
    hookFrame(modal.querySelector('[data-ffp-finder-frame]'));
    load().then(function () {
      if (!D) return;
      walk(modal);
      var loadingText = lookup('Loading product finder…');
      if (loadingText) {
        var st = document.createElement('style');
        st.textContent = '.ffp-finder-modal__dialog::before{content:' + JSON.stringify(loadingText) + '}';
        document.head.appendChild(st);
      }
      var fixEntries = function () {
        document.querySelectorAll('[data-ffp-finder-entry], .ffp-finder-alternative').forEach(function (el) { walk(el); });
      };
      fixEntries();
      var main = document.body;
      var obs = new MutationObserver(fixEntries);
      obs.observe(main, { childList: true, subtree: true });
      setTimeout(function () { obs.disconnect(); }, 15000);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hookPage);
  else hookPage();
})();
